import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Trustedcompany(props) {
  return (
    <div className="trusted_company p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Power Your Growth with TekRevol: Leading Game Development Company
              in UK
            </h2>
            <p>
              TekRevol is among the best game development companies in London
              that brings a wealth of expertise to the table. Our seasoned team
              of online game developers in UK understands the complexities of
              the industry, leveraging the latest technologies and industry
              trends to create immersive and impactful gaming experiences.
            </p>
            <p>
              As one of the finest game studios in UK, our approach goes beyond
              just creating games. We strategically design and develop games
              that align with your business goals by driving customer loyalty.
              We utilize cutting-edge technologies such as Unity and advanced
              programming languages to create games that not only meet but
              exceed industry standards.
            </p>
            <p>
              Power your growth by giving the charge to TekRevol, which is one
              of the leading game design companies in UK.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Let's Connect!
            </Link>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="trustedimg">
              <StaticImage
                src="../../../images/location_new/fold11/Uk.webp"
                alt="TrustedImg"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={775}
                height={670}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Trustedcompany;
